
export enum BooleanQs {
  true= 'true',
  false= 'false',

}